import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { RCAlertBox } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from './../components/shared/url_helpers';

const ListingSellerPaypalOnboardingAlert = () => {
  return (
    <div className="mb-4">
      <RCAlertBox
        type="info"
      >
        <Translate
          className="weight-bold"
          text="productShowPage.listingSellerPaypalOnboardingAlert.title"
        />
        <Translate
          tag="p"
          text="productShowPage.listingSellerPaypalOnboardingAlert.description"
        >
          <span className="weight-bold">
            <CoreLink
              target="_blank"
              to={Paths.shopPoliciesEdit.expand({})}
              className="alert-banner__text-link"
            >
              <Translate text="productShowPage.listingSellerPaypalOnboardingAlert.linkText" />
            </CoreLink>
          </span>
        </Translate>
      </RCAlertBox>
    </div>
  );
};

export default ListingSellerPaypalOnboardingAlert;
